import React, { useEffect, useState } from 'react'
import {
  Btn,
  CustomCheckbox,
  CustomDropdown,
  CustomModal,
  InputNumeroDecimal,
  InputNumeroInteiro,
  InputText,
} from '../../../../components'
import * as ProdutoHttp from '../../../../services/api/https/registration/produto.http'
import { errorHandler } from '../../../../services/util/error.service'
import GrupoProdutoHttp from '../../../../services/api/https/registration/grupo-produto.http'

// -------------------------------------------------------
// Modal Utilizado durante o cadastramento dos produtos
// não-cadastrados durante o processo de importação
// -------------------------------------------------------

const INITIAL_STATE = {
  isLoading: false,
  grupos: [],
  produto: {
    id: null,
    product_code: '',
    company_id: '',
    name: '',
    weight: '',
    weight_liquido: '',
    unit_sku: '',
    m3: '',
    actived: true,
    participa_calculo_paletizacao: true,
    ordem_separacao: '',
    caixa_com_peso_variavel: false,
    grupo: '', // Object
    qte_por_pallet: '',
    dias_para_vencimento: '',
    ean: '',
    dun: '',
    un_agregadora: '',
    un_fracionada: '',
  },
}

function toInputValue(value) {
  return value === null || value === undefined ? '' : String(value)
}

function toNullableNumber(value) {
  return value === '' || value === null || value === undefined ? null : Number(value)
}

const ModalProdutoEan = ({ visible, selectedProduto, onResponse }) => {
  // Hooks
  const [state, setState] = useState({ ...INITIAL_STATE })

  useEffect(() => {
    if (visible && selectedProduto && selectedProduto.company_id) {
      GrupoProdutoHttp.getGrupos(selectedProduto.company_id)
        .then(grupos => {
          setState(prev => ({ ...prev, grupos }))
        })
        .catch(e => onResponse('error', errorHandler(e)))
    }
  }, [visible, selectedProduto && selectedProduto.company_id])

  useEffect(() => {
    if (visible) {
      if (selectedProduto) {
        // propriedades obrigatórias do selectedProduto
        const { product_code, company_id, name, ean, dun, m3, un_agregadora, un_fracionada } =
          selectedProduto
        return setState(prev => ({
          ...prev,
          produto: {
            ...INITIAL_STATE.produto,
            product_code,
            company_id,
            name,
            ean: toInputValue(ean),
            dun: toInputValue(dun),
            m3: toInputValue(m3),
            un_agregadora: un_agregadora || '',
            un_fracionada: un_fracionada || '',
          },
        }))
      } else {
        setState({ ...INITIAL_STATE })
      }
    } else {
      setState({ ...INITIAL_STATE })
    }
  }, [visible])

  // Events
  const onBtnSalvarClicked = async () => {
    try {
      const errorMessage = objectChecker()
      if (errorMessage) {
        onResponse('error', errorMessage)
      } else {
        let _produto = parseProduto()
        setState(prev => ({ ...prev, isLoading: true }))
        if (_produto.id) {
          // Não aplicável para a utilização para cadastro de NOVOS produtos
          // durante o processo de importação
          _produto = await ProdutoHttp.updateProduto(_produto)
        } else {
          _produto = await ProdutoHttp.saveProdutoComEan(_produto)
        }
        onResponse('success', _produto)
      }
    } catch (error) {
      onResponse('error', errorHandler(error))
    } finally {
      setState(prev => ({ ...prev, isLoading: false }))
    }
  }

  // Helpers
  const updateProduto = (fieldName, value) => {
    setState(prev => ({
      ...prev,
      produto: {
        ...prev.produto,
        [fieldName]: value,
      },
    }))
  }

  const objectChecker = () => {
    const { product_code, name, weight, unit_sku, ean, m3 } = state.produto
    if (product_code.toString().trim().length === 0) {
      return 'O campo Código do Produto é obrigatório'
    } else if (name.toString().trim().length === 0) {
      return 'O campo Nome do Produto é obrigatório'
    } else if (Number.isNaN(Number(weight)) || Number(weight) <= 0) {
      return 'O campo Peso Bruto está incorreto'
    } else if (Number.isNaN(Number(unit_sku)) || Number(unit_sku) <= 0) {
      return 'O campo Unit por Caixa está incorreto'
    } else if (Number.isNaN(Number(ean)) || Number(ean) <= 0) {
      return 'O campo Código de Barra está incorreto'
    } else if (Number.isNaN(Number(m3)) || Number(m3) <= 0) {
      return 'O campo Volume m3 é obrigatório'
    }
    return null
  }

  const parseProduto = () => {
    const { ordem_separacao, grupo, qte_por_pallet, weight_liquido, dias_para_vencimento } =
      state.produto

    return {
      ...state.produto,
      weight: Number(state.produto.weight),
      unit_sku: Number(state.produto.unit_sku),
      m3: Number(state.produto.m3),
      ordem_separacao: toNullableNumber(ordem_separacao),
      grupo_produto_id: grupo === '' ? null : grupo.id,
      qte_por_pallet: toNullableNumber(qte_por_pallet),
      weight_liquido: toNullableNumber(weight_liquido),
      dias_para_vencimento: toNullableNumber(dias_para_vencimento),
    }
  }

  // Render
  return (
    <CustomModal
      header="Produto Não Cadastrado"
      isVisible={visible}
      onClose={() => onResponse('close')}
      contentStyle={{ maxHeight: '80vh', overflowY: 'auto' }}
    >
      <form className="p-grid" style={{ width: 650 }}>
        <div className="p-col-12">
          <span style={{ color: '#9e0000', fontSize: '0.8rem' }}>(*) Campos Obrigatórios</span>
        </div>
        <div className="p-col-4">
          <InputText
            disabled={true}
            label="Código (*) :"
            marginTop={10}
            value={state.produto.product_code}
          />
        </div>
        <div className="p-col-12">
          <InputText
            label="Produto (*) :"
            marginTop={10}
            value={state.produto.name}
            onChange={value => updateProduto('name', value)}
          />
        </div>
        <div className="p-col-4">
          <InputNumeroDecimal
            label="Peso Bruto por Caixa/Volume (*):"
            value={state.produto.weight}
            onChange={value => updateProduto('weight', value)}
          />
        </div>
        <div className="p-col-4">
          <InputNumeroDecimal
            label="Peso Liquido por SKU :"
            value={state.produto.weight_liquido}
            onChange={value => updateProduto('weight_liquido', value)}
          />
        </div>
        <div className="p-col-4">
          <InputNumeroInteiro
            label="Unidade por SKU (*) :"
            value={state.produto.unit_sku}
            onChange={value => updateProduto('unit_sku', value)}
          />
        </div>
        <div className="p-col-4">
          <InputNumeroInteiro
            label="Qte Por Pallet :"
            value={state.produto.qte_por_pallet}
            onChange={value => updateProduto('qte_por_pallet', value)}
          />
        </div>
        <div className="p-col-4">
          <InputNumeroDecimal
            label="Volume m3 por Sku (*) :"
            decimalScale={4}
            value={state.produto.m3}
            onChange={value => updateProduto('m3', value)}
          />
        </div>
        <div className="p-col-4">
          <InputNumeroInteiro
            label="Dias Para Vencimento :"
            marginTop={20}
            value={state.produto.dias_para_vencimento}
            onChange={value => updateProduto('dias_para_vencimento', value)}
          />
        </div>
        <div className="p-col-6">
          <InputNumeroInteiro
            label="Ordem de Separação :"
            marginTop={10}
            value={state.produto.ordem_separacao}
            onChange={value => updateProduto('ordem_separacao', value)}
          />
        </div>
        <div className="p-col-6">
          <CustomDropdown
            label="Grupo de Produto"
            optionLabel="nome"
            options={state.grupos}
            value={state.produto.grupo}
            onChange={value => updateProduto('grupo', value)}
          />
        </div>
        <div className="p-col-6">
          <InputText
            label="Unidade Agregadora :"
            marginTop={10}
            value={state.produto.un_agregadora}
            onChange={value => updateProduto('un_agregadora', value)}
          />
        </div>
        <div className="p-col-6">
          <InputText
            label="Unidade Fracionada :"
            marginTop={10}
            value={state.produto.un_fracionada}
            onChange={value => updateProduto('un_fracionada', value)}
          />
        </div>
        <div className="p-col-2" style={{ paddingTop: 45 }}>
          <CustomCheckbox
            onChange={value => updateProduto('actived', value)}
            checked={state.produto.actived}
          >
            Ativo
          </CustomCheckbox>
        </div>
        <div className="p-col-4" style={{ paddingTop: 45 }}>
          <CustomCheckbox
            onChange={value => updateProduto('caixa_com_peso_variavel', value)}
            checked={state.produto.caixa_com_peso_variavel}
          >
            Caixa Com Peso Variável
          </CustomCheckbox>
        </div>
        <div className="p-col-6" style={{ paddingTop: 45 }}>
          <CustomCheckbox
            onChange={value => updateProduto('participa_calculo_paletizacao', value)}
            checked={state.produto.participa_calculo_paletizacao}
          >
            Participa do Cálculo de Paletização
          </CustomCheckbox>
        </div>

        <div className="p-col-6">
          <InputNumeroInteiro
            label="Código de Barra (*) :"
            marginTop={10}
            value={state.produto.ean}
            onChange={value => updateProduto('ean', value)}
          />
        </div>
        <div className="p-col-6">
          <InputNumeroInteiro
            label="DUN:"
            marginTop={10}
            value={state.produto.dun}
            onChange={value => updateProduto('dun', value)}
          />
        </div>
        <div className="p-col-12" style={{ paddingTop: 32 }}>
          <Btn isLoading={state.isLoading} onClick={onBtnSalvarClicked}>
            Salvar
          </Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default ModalProdutoEan
